var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbDownRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0556 14.1829C15.5164 15.6099 15.7491 16.859 15.7491 17.9361C15.7491 20.3348 14.81 22.1835 13.2491 22.1835C12.4493 22.1835 12.1712 21.7338 11.8665 20.637L11.5968 19.6155C11.4958 19.2568 11.32 18.646 11.0697 17.7845C11.063 17.7614 11.0532 17.7397 11.0403 17.7196L8.17359 13.2339C7.49554 12.173 6.49507 11.3575 5.31919 10.9073L4.06196 10.4259C3.26859 10.1221 2.80797 9.29247 2.96968 8.45847L3.65584 4.9198C3.82298 4.05781 4.47629 3.3718 5.32909 3.16278L13.5786 1.14085C16.1098 0.520459 18.6682 2.05539 19.3121 4.58072L20.886 10.7534C21.2612 12.2251 20.3723 13.7224 18.9007 14.0976C18.6786 14.1542 18.4504 14.1829 18.2212 14.1829H15.0556Z",
    fill: "#e82626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownRed);
export default __webpack_public_path__ + "static/media/thumb-down-red.b73d02199a546609ca304888e251283d.svg";
export { ForwardRef as ReactComponent };